const formatResponse = (response: any) => {
    const buckets = response?.aggregations?.usuarios?.buckets || []
    const formattedData = buckets.map((bucket: any) => {
        const ultimoRegistro = bucket.ultimo_registro?.hits?.hits?.[0]?._source || {}
        const usuarioNombre = ultimoRegistro.usuario || 'Sin nombre'
        const totalProgramado = bucket.total_programado?.value || 0
        const totalNoEjecutado = bucket.total_no_ejecutado?.value || 0
        const totalFinalizado = bucket.total_finalizado?.value || 0
        const promedioResultado = bucket.promedio_resultado?.value || 0
        const percentNotExecuted = totalProgramado > 0 
            ? ((totalNoEjecutado / totalProgramado) * 100).toFixed(1)
            : '0.0'
        const percentFinished = totalProgramado > 0 
            ? ((totalFinalizado / totalProgramado) * 100).toFixed(1)
            : '0.0'
        return {
            id: ultimoRegistro.usuario_id || bucket.key, 
            user: usuarioNombre,
            schedules: Math.round(totalProgramado),
            notExecuted: Math.round(totalNoEjecutado),
            percentNotExecuted: `${percentNotExecuted}%`,
            finished: Math.round(totalFinalizado),
            percentFinished: `${percentFinished}%`,
            result: promedioResultado ? `${promedioResultado.toFixed(1)}%` : '0.0%',
            redirect: '',
            actions: '',
            userId: ultimoRegistro.usuario_id || bucket.key,
            roleId: ultimoRegistro.role_id,
            unidadId: ultimoRegistro.unidad_id,
            unidad: ultimoRegistro.unidad,
            cuestionarioId: ultimoRegistro.cuestionario_id,
            cuestionario: ultimoRegistro.cuestionario,
            gerenteId: ultimoRegistro.gerente_id,
            gerenteNombre: ultimoRegistro.gerente_nombre,
            supervisorId: ultimoRegistro.supervisor_id,
            supervisorNombre: ultimoRegistro.supervisor_nombre,
            ultimaFecha: bucket.ultima_fecha?.value_as_string || '',
            semana: ultimoRegistro.semana || '',
        }
    })

    const totalesPorRoleBuckets = response?.aggregations?.totales_por_role?.buckets || []
    const totalesPorRole = totalesPorRoleBuckets.reduce((acc: any, bucket: any) => {
        const roleId = bucket.key
        acc[roleId] = {
            roleId: roleId,
            totalProgramado: Math.round(bucket.total_programado_role?.value || 0),
            totalNoEjecutado: Math.round(bucket.total_no_ejecutado_role?.value || 0),
            totalFinalizado: Math.round(bucket.total_finalizado_role?.value || 0),
            promedioResultado: bucket.promedio_resultado_role?.value || 0,
        }
        return acc
    }, {})
    
    return {
        data: formattedData,
        total: buckets.length,
        totalesPorRole: totalesPorRole
    }
}

export { formatResponse }
